import _AnimatedLink from "./AnimatedLink.vue";
import _AppIconSelector from "./AppIconSelector.vue";
import _CreateAppRedirectButton from "./CreateAppRedirectButton.vue";
import _ValidateButton from './ValidateButton.vue';
import _CancelButton from './CancelButton.vue';
import _PwaInstallButton from "./PwaInstallButton.vue";
import _Sidebar from "./Sidebar.vue";
import _Stars from "./Stars.vue";
import _Toast from "./Toast.vue";
import _Loader from './Loader.vue';

export const AnimatedLink = _AnimatedLink;
export const AppIconSelector = _AppIconSelector;
export const CreateAppRedirectButton = _CreateAppRedirectButton;
export const ValidateButton = _ValidateButton;
export const CancelButton = _CancelButton;
export const PwaInstallButton = _PwaInstallButton;
export const Sidebar = _Sidebar;
export const Stars = _Stars;
export const Toast = _Toast;
export const Loader = _Loader;

export * from '@/views';
